"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VersionInfo_1 = __importDefault(require("@features/ItemCommon/components/VersionInfo"));
var DecisionSummary_1 = require("src/react-app/features/ItemCommon/components/DecisionSummary");
var ItemCommon_1 = __importDefault(require("@features/ItemCommon"));
var OlderJobVersions_1 = __importDefault(require("@features/ItemCommon/components/OlderJobVersions"));
function ItemWithRevision(_a) {
    var job = _a.job, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, updateItemCurrent = _a.updateItemCurrent, updateItemCustomerSpecific = _a.updateItemCustomerSpecific, updateFeedback = _a.updateFeedback, updateModerationNotes = _a.updateModerationNotes, isUsingImageGallery1 = _a.isUsingImageGallery1, isUsingImageGallery2 = _a.isUsingImageGallery2, editPermissions = _a.editPermissions, template = _a.template, index = _a.index, onSelectDecision = _a.onSelectDecision, olderJobs = _a.olderJobs, isFocused = _a.isFocused, setJob = _a.setJob, changeFocusedElement = _a.changeFocusedElement;
    if (!job.ad) {
        return null;
    }
    var _b = __read(react_1.default.useState(false), 2), shwOldJobs = _b[0], setShwOldJobs = _b[1];
    var jobRef = react_1.default.useRef(null);
    var itemCommonProps = {
        domain: domain,
        updateItemCurrent: updateItemCurrent,
        updateItemCustomerSpecific: updateItemCustomerSpecific,
        angularJsDependencies: angularJsDependencies,
        isUsingImageGallery1: isUsingImageGallery1,
        isUsingImageGallery2: isUsingImageGallery2,
        updateFeedback: updateFeedback,
        updateModerationNotes: updateModerationNotes,
        editPermissions: editPermissions,
        template: template,
        onSelectDecision: onSelectDecision,
        changeFocusedElement: changeFocusedElement,
    };
    var toggleJobs = function () {
        if (!shwOldJobs) {
            // vm.olderJobs.forEach((job) => {
            //   job.shouldDeferLoadingImages = false;
            // });
        }
        setShwOldJobs(!shwOldJobs);
    };
    var scrollToLatestJob = function () {
        var _a;
        var elementTop = (_a = jobRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop;
        if (elementTop === undefined)
            return;
        var navigationBarHeight = 100;
        var jobVersionInfoHeight = 40;
        window.scrollTo({
            top: elementTop - navigationBarHeight - jobVersionInfoHeight - 10,
            behavior: 'smooth',
        });
    };
    var onVersionInfoLinkClicked = function () { };
    return (react_1.default.createElement("div", { className: "job-group js-job-group eva-keyboard-focusable", "data-cy": "job-group-".concat(job.ad.remoteId.id) },
        shwOldJobs && react_1.default.createElement(VersionInfo_1.default, { historyItem: job.ad.history[0], hideLink: true, onLinkClicked: onVersionInfoLinkClicked }),
        react_1.default.createElement(DecisionSummary_1.DecisionSummary, { job: job, hideStatus: false }),
        react_1.default.createElement("div", { className: "eva-job flex-container", ref: jobRef },
            react_1.default.createElement(ItemCommon_1.default, __assign({ job: job, index: index, enableKeyboardShortcuts: isFocused }, itemCommonProps, { editMode: true, setCurrentItem: setJob }))),
        olderJobs && olderJobs.length > 0 && (react_1.default.createElement(OlderJobVersions_1.default, __assign({ showOldJobs: shwOldJobs, toggleJobs: toggleJobs, jobs: olderJobs, scrollToLatestJob: scrollToLatestJob }, itemCommonProps))),
        react_1.default.createElement("hr", { className: "version-divider last-divider" })));
}
exports.default = ItemWithRevision;
